/*

    Форма ввода данных в обычный TextBox.
    Есть клавиатура

    при создании объекта, надо создать пропсы:
    
        cnTextBox - className TextBox
        value - значение по умолчанию
        onChange - событие для изменения значения
*/


import './TextBox.css';
import { useState, useEffect } from 'react'
import unique from '../modules/unique';



function TextBox(props) {
 

    const [result_text, SetResultText] = useState("");                      // набранный текст
    const [is_entering_text, SetEnteringText] = useState("");               // true, если показывать модальное окно ввода текста
    const [cnTextBox, SetCNTextBox] = useState("");                         // класс TextBox
    const [isCaseSimbol, SetIsCaseSimbol] = useState(false);                  // заглавные буквы или нет

    const alphabet = ["ЙЦУКЕНГШЩЗХЪ", "ФЫВАПРОЛДЖЭ<", "ЯЧСМИТЬБЮ.,-", "@ @"];
    const alphabet_u = ["йцукенгшщзхъ", "фывапролджэ<", "ячсмитьбю.,-", "@ @"];
    const cifir = ["789", "456", "123", ".0"];

    useEffect(() => { setDefaultValue(props.value) }, [props.value]);
    useEffect(() => { SetCNTextBox(props.cnTextBox) }, [props.cnTextBox]);

    //useEffect(() => { SetIsCaseSimbol() }, [isCaseSimbol]);


    function setDefaultValue(value)
    {
        if(value !== undefined && value != null) SetResultText(value);
    }

  return (      

    <>
        <div className={ cnTextBox } onClick={ () => SetEnteringText(true) }>{ props.value }</div>
        { is_entering_text && (
          <div className="wrap">
              <div className="modal">

                <div className="caption">{ props.caption }</div>
                <div className="textboxgrid">
                    <div className="text">{ result_text }</div>
                </div>

                <div className="container-fluid row">


                    <div className="col-8 alphabet">
                        { getAlphabet() }
                    </div>

                    <div className="col-1"></div>

                    <div className="col-2">
                        { getCifir() }
                    </div>

                </div>

                <br /> <br />

                <div className="container-fluid">
                    <button type="button" className="btn btn-info btn-lg result" onClick={ () => setDefaultValue("") }>Очистить</button>
                    <button type="button" className="btn btn-warning btn-lg result" onClick={ () => SetEnteringText(false) }>Отмена</button>
                    <button type="button" className="btn btn-success btn-lg result" onClick={ () => Success() }>ОК</button>                    
                </div>

              </div>            
          </div>
        )}
    </>
  );


    // показать кнопки букв
    function getAlphabet()
    {
        let alph = alphabet;
        if(isCaseSimbol == true) alph = alphabet_u;
        let keys = [];
        for(let i in alph)
        {
            let str = alph[i];
            let str_keys = [];
            for(let j = 0; j < str.length; j++)
            {
                let simbol = str[j];
                str_keys.push(getOneKey(simbol));
            }
            keys.push(<div key={ unique() } className="row">{ str_keys }</div>);
        }
        return keys;
    }

    // показать кнопки цифр
    function getCifir()
    {
        let keys = [];
        for(let i in cifir)
        {
            let str = cifir[i];
            let str_keys = [];
            for(let j = 0; j < str.length; j++)
            {
                let simbol = str[j];
                str_keys.push(getOneKey(simbol));
            }
            keys.push(<div key={ unique() } className="row">{ str_keys }</div>);
        }
        return keys;
    }

    function getOneKey(simbol)
    {        
        if(simbol == '<')
          return <div key={ unique() } className="col key d-flex justify-content-center align-items-center backspace" onClick={ (e) => ClickKey(e, simbol)}>{simbol}</div>

        if(simbol == '@')
          return <div key={ unique() } className="col-1 key d-flex justify-content-center align-items-center shift" onClick={ () => ClickKeyShift()}></div>


        return <div key={ unique() } className="col key d-flex justify-content-center align-items-center" onClick={ (e) => ClickKey(e, simbol)}>{simbol}</div>        
    }  

    // кликнули на кнопку
    function ClickKey(obj, simbol)
    {
        let txt = result_text;        
        if(simbol == '<') { if(txt.length > 0) txt = txt.substring(0, txt.length - 1); }        // если пользователь удаляет символ        
        else
        {            
            // надо добавить символ
            txt += simbol;

            // если символ был заглавный, перейдем на простые
            if(isCaseSimbol == false) SetIsCaseSimbol(true);
        }
        
        let bg = obj.target.style.backgroundColor;
        obj.target.style.backgroundColor = '#303144';
        setTimeout(function(){ obj.target.style.backgroundColor = bg; SetResultText(txt);}, 100);      
    }

    // кликнули на Shift
    function ClickKeyShift()
    {
        SetIsCaseSimbol(!isCaseSimbol);
    }

    function Success()
    {
        if(props.onChange !== undefined && props.onChange != null) props.onChange(result_text);
        SetEnteringText(false);
    }

}

export default TextBox;
